// extracted by mini-css-extract-plugin
module.exports = {"contact":"modal-content-width-contact_contact__QZGw9","icon":"modal-content-width-contact_icon__1cn1c"};